var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showWitch() == 0)?_c('Index1'):(_vm.showWitch() == 1)?_c('Index2'):_c('Index3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }